import { AuditLogItem } from "../types/auditLogTypes";
import { PaginationParameters, PaginationResult, toQueryParameters } from "./Pagination";
import { CallResult, doApiGet } from "./Requests";

export const auditLogsApi = {
  getAuditLogs: async (
    pagination: PaginationParameters
  ): Promise<CallResult<PaginationResult<AuditLogItem>>> => {
    return await doApiGet<PaginationResult<AuditLogItem>>(
        `/api/companies/current/auditlogs?${toQueryParameters(pagination)}`
    );
  },
};